import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  doctorSection: ({ colors }) => css`
    width: 400px;
    height: 120px;
    .consultation-with {
      font-size: 18px;
      color: ${colors.neutral[900]};

      span:last-of-type {
        font-size: 16px;
        color: ${colors.neutral[500]};
      }
    }
  `,
  avatar: () => css`
    margin-right: 16px;
  `,
})

export default useStyles
